var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-file-input',{attrs:{"label":"File input","filled":""},on:{"change":_vm.uploadFile},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }